import * as _utils from './_utils';

const qa: () => Env = () => {
  const envcode: Envcode = 'qa';

  return {
    NAME: 'QA環境',
    COGNITO_REGION: 'us-west-2',
    COGNITO_USER_POOL_ID: 'us-west-2_hKlG60I5s',
    COGNITO_CLIENT_ID: '71cenlhfbgkbo64bv59hg5nh4e',
    COGNITO_REDIRECT_URI: 'https://qa.anpichecker.com/signin',
    COGNITO_DOMAIN: 'https://tf-an-qa.auth.us-west-2.amazoncognito.com',
    API_ENDPOINT: 'https://stg.api.anpichecker.com/qa',
    ENVCODE: envcode,
    TITLE: _utils.getName(envcode),
    STRIPE_PK: 'pk_test_aLCDECowCWXrI6io12XOoD1Y00ZQdcuR1j',
    RECAPTCHA_SITE_KEY: '6LeA_uwUAAAAAJRa8iDis4Ql9wjrZzzO_uxyY7ED',
  };
};

export default qa();
